module.exports = __webpack_public_path__ + "static/media/chat.0c707ee6.png";